<template>
  <div>
    <el-dialog
        :title="isEdit? '办卡信息修改':'办卡信息展示'"
        :visible.sync="dialogVisible"
        width="808px"
        v-if="proptions.length>0"
        :before-close="close"
        :close-on-click-modal="false">
      <div>
        <el-form ref="form" class="formSty" :inline="true" label-position="top" :rules="isEdit ? rules:{}"
                 :model="form">
          <div class="changeClass">
            <div v-if="nrData.type=='1'||!nrData.type" @click="changeTab(false)" :class="{active:!isShowNormal}">
              联名卡
            </div>
            <div v-if="nrData.type=='2'||!nrData.type" @click="changeTab(true)" :class="{active:isShowNormal}">普通卡
            </div>
          </div>
          <div class="title">
            <i></i>
            企业信息
          </div>
          <el-form-item label="客户名称" prop="companyNameMask">
            <el-tooltip placement="top" content="点击解密">

              <div @click="showVal('companyNameMask','companyName')">
                <el-input v-model="form.companyNameMask" disabled
                          style="pointer-events: none;width: 357px;"
                          placeholder="请输入客户名称"
                ></el-input>
              </div>

            </el-tooltip>
          </el-form-item>
          <el-form-item label="统一社会信用代码" prop="companyCreditCodeMask">
            <el-tooltip placement="top" content="点击解密">
              <div @click="showVal('companyCreditCodeMask','companyCreditCode')">
                <el-input v-model="form.companyCreditCodeMask" disabled
                          placeholder="请输入统一社会信用代码"
                          style="width: 357px;pointer-events: none;"></el-input>
              </div>
            </el-tooltip>
          </el-form-item>
          <el-form-item label="所属省份" prop="pr">
            <!--          <el-input v-model="form.prcicu" disabled placeholder="请选择所属省/市/县" style="width: 357px"></el-input>-->
            <el-select v-model="form.pr" disabled @change="prChange" style="width: 357px"
                       placeholder="请选择所属省份">
              <el-option
                  v-for="item in proptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所属城市" prop="ci">
            <!--          <el-input v-model="form.prcicu" disabled placeholder="请选择所属省/市/县" style="width: 357px"></el-input>-->
            <el-select v-model="form.ci" disabled @change="ciChange" style="width: 357px"
                       placeholder="请选择所属城市">
              <el-option
                  v-for="item in cioptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所属区县" prop="cu">
            <!--          <el-input v-model="form.prcicu" disabled placeholder="请选择所属区县" style="width: 357px"></el-input>-->
            <el-select v-model="form.cu" disabled style="width: 357px"
                       placeholder="请选择所属区县">
              <el-option
                  v-for="item in cuoptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客户姓名" prop="contactName">
            <el-input v-model="form.contactName"
                      maxlength="20"
                      :disabled="!isEdit"
                      placeholder="请输入客户姓名"
                      style="width: 357px;"></el-input>
          </el-form-item>
          <el-form-item label="客户手机号码" prop="contactPhone">
            <el-input v-model="form.contactPhone"
                      :disabled='!isEdit'
                      placeholder="请输入客户手机号码"
                      style="width: 357px;"></el-input>
          </el-form-item>
          <div v-if="(nrData.type=='2'||!nrData.type)&&isShowNormal">
            <div class="title">
              <i></i>
              基础信息
            </div>
            <el-form-item label="是否已有普通卡" prop="commonCardStatus">
              <el-select v-model="form.commonCardStatus" disabled style="width: 357px" placeholder="请选择">
                <el-option
                    v-for="item in optionsCommonCardStatus"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
                v-if="form.commonCardStatus=='1'"
                v-for="(domain, index) in form.domains"
                :key="domain.key"
                :label="index==0?'普通卡主卡卡号及有效卡数量':''"
                :prop="'domains.' + index "

            >
<!--              :rules="isEdit?{-->
<!--              required: true, validator: ruleMobile, trigger: 'blur'-->
<!--              }:{}"-->
              <div class="cardMesSty">

                <el-input disabled style="width: 357px;margin-right: 30px"
                          placeholder="请输入19位卡号" maxlength=19
                          v-model="domain.value"></el-input>
                <el-input disabled style="width: 267px" placeholder="请输入有效卡数量" maxlength=7
                          v-model="domain.value2"></el-input>
                <img src="../assets/images/icon_add.png" style="margin-left: 20px" @click.prevent="addDomain()"
                     width="32" height="32" alt="">
                <img src="../assets/images/icon_delet.png" v-if="form.domains.length>1" style="margin-left: 8px"
                     @click.prevent="removeDomain(domain)" width="32" height="32" alt="">
              </div>
            </el-form-item>
            <div v-if="form.commonCardStatus=='1'">
              <div class="title">
                <i></i>
                优惠信息
              </div>
              <el-form-item
                  v-for="(domain, index) in form.domains2"
                  :key="domain.key"
                  :label="index==0?'普通卡主卡卡号及有效卡数量':''"
                  :prop="'domains2.' + index "
              >
<!--                :rules="isEdit?{-->
<!--                required: true, validator: ruleMobile, trigger: 'blur'-->
<!--                }:{}-->
<!--                "-->
                <div class="cardMesSty">
                  <el-input disabled style="width: 357px;margin-right: 30px"
                            placeholder="请输入19位卡号" maxlength=19
                            v-model="domain.value"></el-input>
                  <el-input disabled style="width: 357px" placeholder="请输入有效卡数量" maxlength=7
                            v-model="domain.value2"></el-input>
                </div>
              </el-form-item>
              <el-form-item label="是否有专属优惠" prop="vipDiscount2">
                <el-select v-model="form.vipDiscount2" disabled style="width: 357px"
                           placeholder="请选择是否有专属优惠">
                  <el-option
                      v-for="item in vipDiscountOption"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item v-if="form.vipDiscount2=='1'" label="优惠类别" prop="discountType2">
                <el-select v-model="form.discountType2" disabled style="width: 357px"
                           placeholder="请选择优惠类别">
                  <el-option
                      v-for="item in discountTypeOption"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item v-if="form.vipDiscount2=='1'" label="备注" prop="remark2">
                <el-input v-model="form.remark2" type="textarea"
                          placeholder="请输入具体优惠政策等信息"
                          disabled
                          maxlength="200"
                          :rows="2" style="width: 746px"></el-input>
              </el-form-item>
            </div>
          </div>
          <div v-if="(nrData.type=='1'||!nrData.type)&&!isShowNormal">
            <div class="title">
              <i></i>
              基础信息
            </div>
            <el-form-item label="是否有联名卡" prop="cardStatus">
              <el-select v-model="form.cardStatus" disabled style="width: 357px" placeholder="请选择是否有联名卡">
                <el-option
                    v-for="item in cardStatusOption"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="form.cardStatus == 1" label="联名卡办卡数量">
              <el-input v-model="form.cardCount" disabled style="width: 357px"></el-input>
            </el-form-item>
            <div v-if="form.cardStatus == 1">
              <el-form-item v-for="(item,index) in form.cardNos" :label="index==0?'联名卡主卡卡号':''">
                <el-input :value="item" disabled style="width: 357px;"
                          :style="{marginTop:index==1?'30px':'0'}"></el-input>
              </el-form-item>
            </div>
            <div v-if="form.cardStatus == 1">
              <div class="title">
                <i></i>
                优惠信息
              </div>
              <el-form-item label="联名卡主卡卡号" prop="cardNo">
                <el-select v-model="form.cardNo" disabled style="width: 357px" placeholder="请选择">
                  <el-option
                      v-for="item in qqqOption"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="是否有专属优惠" prop="vipDiscount">
                <el-select v-model="form.vipDiscount" disabled style="width: 357px"
                           placeholder="请选择是否有专属优惠">
                  <el-option
                      v-for="item in vipDiscountOption"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item v-if="form.vipDiscount=='1'" label="优惠类别" prop="discountType">
                <el-select v-model="form.discountType" disabled style="width: 357px"
                           placeholder="请选择优惠类别">
                  <el-option
                      v-for="item in discountTypeOption"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item v-if="form.vipDiscount=='1'" label="备注" prop="remark">
                <el-input v-model="form.remark" disabled type="textarea"
                          placeholder="请输入具体优惠政策等信息"
                          maxlength="200"
                          :rows="2" style="width: 746px"></el-input>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
          <div class="btn_Sub" v-if="isEdit" @click="subTask('form')">提 交</div>
                  <div class="btn_Clo" @click="close">{{ isEdit ? '取 消' : '关 闭' }}</div>
        </span>
    </el-dialog>

  </div>
</template>
<script>
import http from "api/freight";
import Util from "utils/util";

export default {
  props: {
    nrData: {
      type: Object,
      default: {}
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    cardNum: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isShowNormal: false,
      form: {
        companyNameMask: '',
        companyCreditCodeMask: '',
        pr: '',
        ci: '',
        cu: '',
        contactName: '',
        contactPhone: '',
        cardStatus: '',
        cardCount: '',
        cardNos: '',
        cardNo: '',
        vipDiscount: '',
        discountType: '',
        remark: '',
        commonCardStatus: '',
        vipDiscount2: '',
        discountType2: '',
        remark2: '',
        domains: [{
          value: this.cardNum ? this.cardNum : '',
          value2: ''
        }],
        domains2: [{
          value: this.cardNum ? this.cardNum : '',
          value2: ''
        }],
      },
      vipDiscountOption: [
        {
          value: '1',
          label: '是'
        }, {
          value: '0',
          label: '否'
        }
      ],
      discountTypeOption: Util.discountTypeOption,
      cardStatusOption: [
        {
          label: '是',
          value: '1'
        },
        {
          label: '否',
          value: '0'
        }
      ],
      optionsCommonCardStatus: [
        {
          value: '1',
          label: '是'
        }, {
          value: '0',
          label: '否'
        }
      ],
      rules: {
        // companyNameMask: [
        //   {
        //     required: true,
        //     message: "请输入客户名称",
        //     trigger: "blur",
        //   },
        // ],
        // pr: [
        //   {
        //     required: true,
        //     message: "请选择所属省份",
        //     trigger: "blur",
        //   },
        // ],
        // ci: [
        //   {
        //     required: true,
        //     message: "请选择所属城市",
        //     trigger: "blur",
        //   },
        // ],
        // cu: [
        //   {
        //     required: true,
        //     message: "请选择所属区县",
        //     trigger: "blur",
        //   },
        // ],
        contactName: [
          {
            required: true,
            message: "请输入客户姓名",
            trigger: "blur",
          },
        ],
        contactPhone: [
          {required: true, validator: this.rulePhone, trigger: 'blur'},
        ],
        // cardNo: [{required: true, message: "请选择联名卡主卡", trigger: "change"}],
        // vipDiscount: [{required: true, message: "请选择是否专属优惠", trigger: "change"}],
        // discountType: [{required: true, message: "请选择优惠类别", trigger: "change"}],
        // remark: [
        //   {
        //     required: true,
        //     message: "请输入具体优惠政策等信息",
        //     trigger: "blur",
        //   },
        // ],
        // vipDiscount2: [{required: true, message: "请选择是否专属优惠", trigger: "change"}],
        // discountType2: [{required: true, message: "请选择优惠类别", trigger: "change"}],
        // remark2: [
        //   {
        //     required: true,
        //     message: "请输入具体优惠政策等信息",
        //     trigger: "blur",
        //   },
        // ],
        // commonCardStatus: [{required: true, message: "请选择是否已有普通卡", trigger: "change"}],
      },
      dialogVisible: true,
      proptions: [],
      cioptions: [],
      cuoptions: [],
      qqqOption: [],
      mobileReg: /^1(?:3\d|4[4-9]|5[0-35-9]|6[67]|7[013-8]|8\d|9\d)\d{8}$/,
      currRow: {},
    }
  },
  // computed: {
  //   areaList() {
  //     let nerArr = JSON.parse(JSON.stringify(this.$store.getters.areaList))
  //     if (nerArr.length > 0) {
  //       nerArr.forEach(item => {
  //         item.value = item.provinceCode + '0000'
  //         item.label = item.provinceName
  //       })
  //     }
  //     if (nerArr.length == 1) {
  //       this.cardNum = Util.keyValueCardNum[nerArr[0].provinceCode]
  //     }
  //     return nerArr
  //   },
  // },
  mounted() {
    if (this.nrData.type == '2') {
      this.isShowNormal = true
    }
    this.getPrev()
    this.getInfo()
  },
  methods: {
    getPrev() {
      http.getCountyAreaList({
        code: '0',
        areaType: 'PROVINCE'
      }).then((e) => {
        if (e.data.length > 0) {
          this.proptions = e.data
              .map(item => ({
                value: item.code,
                label: item.name,
              }));
        }
      })
    },
    subTask(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = {
            cardType: this.nrData.type,
            contactName: this.form.contactName,
            contactPhone: this.form.contactPhone,
            id: this.currRow.id,
          }
          if (this.nrData.type == '1') {
            params.cbCardDiscount = {
              cardNo: this.form.cardNo,
              vipDiscount: this.form.vipDiscount,
              discountType: this.form.discountType,
              remark: this.form.remark,
            }
          } else {
            params.commonCardDiscount = {
              cardNo: this.form.vipDiscount2 == '1' ? this.form.domains2[0].value + '_' + this.form.domains2[0].value2 : '',
              vipDiscount: this.form.vipDiscount2,
              discountType: this.form.discountType2,
              remark: this.form.remark2,
            }
            if (this.form.commonCardStatus == '1') {
              console.log(123123)
              let commonCardNos = []
              this.form.domains.forEach(item => {
                commonCardNos.push(item.value + '_' + item.value2)
              })
              params.commonCardNos = commonCardNos
            }
          }

          http
              .updateCardInfo(params)
              .then((e) => {
                if (e.code == 200) {
                  this.$message({
                    message: '修改资料成功',
                    type: 'success',
                  })
                  this.$emit('changeDetail')
                }
              })
        }
      })
    },
    removeDomain(item) {
      if (!this.isEdit) {
        return
      }
      var index = this.form.domains.indexOf(item)
      if (index !== -1) {
        this.form.domains.splice(index, 1)
      }
    },
    addDomain() {
      if (!this.isEdit) {
        return
      }
      console.log(this.cardNum)
      this.form.domains.push({
        value: this.cardNum != '' ? this.cardNum : '',
        value2: '',
        key: Date.now()
      });
    },
    getInfo() {
      let params = {
        id: this.nrData.id,
      }
      this.qqqOption = []
      http
          .cardInfoAll(params)
          .then((e) => {
            console.log(e)
            if (e.code == 200) {
              if (e.data.cbCardInfo.cardNos) {
                e.data.cbCardInfo.cardNos.forEach(item => {
                  this.qqqOption.push({
                    value: item,
                    label: item
                  })
                })
              }
              const baseMees = e.data.companyInfo
              this.form.companyNameMask = baseMees.companyNameMask
              this.form.companyCreditCodeMask = baseMees.companyCreditCodeMask
              this.form.pr = baseMees.provcode
              this.form.ci = baseMees.citycode
              this.form.cu = baseMees.countycode
              this.form.contactName = baseMees.contactName
              this.form.contactPhone = baseMees.contactPhone
              this.currRow = baseMees
              this.prChange()
              const cbCardInfo = e.data.cbCardInfo
              this.form.cardStatus = cbCardInfo.cardStatus.toString()
              this.form.cardCount = cbCardInfo.cardCount
              this.form.cardNos = cbCardInfo.cardNos
              const cbCardDiscount = e.data.cbCardDiscount
              this.form.cardNo = cbCardDiscount.cardNo
              this.form.vipDiscount = cbCardDiscount.vipDiscount.toString()
              this.form.discountType = cbCardDiscount.discountType.toString()
              this.form.remark = cbCardDiscount.remark
              const commonCardInfo = e.data.commonCardInfo
              this.form.commonCardStatus = commonCardInfo.cardStatus.toString()
              if (commonCardInfo.cardNos) {
                this.form.domains = []
                commonCardInfo.cardNos.forEach(item => {
                  let val = item.split('_')
                  this.form.domains.push({
                    value: val[0],
                    value2: val[1]
                  })
                })
              }
              const commonCardDiscount = e.data.commonCardDiscount
              if (commonCardDiscount.cardNo) {
                this.form.domains2 = []
                let val = commonCardDiscount.cardNo.split('_')
                this.form.domains2.push({
                  value: val[0],
                  value2: val[1]
                })
              }
              this.form.vipDiscount2 = commonCardDiscount.vipDiscount.toString()
              this.form.discountType2 = commonCardDiscount.discountType.toString()
              this.form.remark2 = commonCardDiscount.remark
            }
          })
    },
    async ciChange() {
      this.cuoptions = []
      this.form.cu = ''
      const {data} = await http.getCountyAreaList({
        code: this.form.ci,
        areaType: 'COUNTY'
      })
      if (data.length > 0) {
        this.cuoptions = data
            .map(item => ({
              value: item.code,
              label: item.name,
            }));
      } else {
        this.cuoptions = this.cioptions.filter(item => item.value == this.form.ci)
      }
      this.form.cu = this.currRow.countycode
    },
    ruleMobile(rule, value, callback) {
      if (!value.value || !value.value2) {
        callback(new Error('请输入主卡卡号及有效卡数量!'))
      } else {
        if (!/^\d+$/.test(value.value) || !/^\d+$/.test(value.value2)) {
          callback(new Error('请输入数字!'))
        } else {
          if (value.value.length == 19) {
            callback();
          } else {
            callback(new Error('请输入主卡卡号19位数字!'))
          }
        }
      }
    },
    prChange() {
      this.cuoptions = []
      this.cioptions = []
      this.form.ci = ''
      this.form.cu = ''
      http.getCountyAreaList({
        code: this.form.pr,
        areaType: 'CITY'
      }).then((e) => {
        if (e.data.length > 0) {
          this.cioptions = e.data
              .map(item => ({
                value: item.code,
                label: item.name,
              }));
          this.form.ci = this.currRow.citycode
          this.ciChange()
        }
      })
    },
    showVal(oldVal, newVal) {
      this.form[oldVal] = this.currRow[newVal]
    },
    changeTab(val) {
      this.isShowNormal = val
    },
    close() {
      this.$emit('changeDetail')
    },
    rulePhone(rule, value, callback) {
      let reg = this.mobileReg
      if (!value) {
        callback(new Error('请输入客户手机号码'));
      } else if (!reg.test(value)) {
        callback(new Error('请输入正确的客户手机号码'));
        // this.codeStatus = true
      } else {
        if (!this.time) {
          // this.codeStatus = false
        }
        callback();
      }
    },
    companyCred(rule, value, callback) {
      if (value) {
        if (!this.isShowInput) {
          if (!/^[A-Za-z0-9]+$/.test(value)) {
            callback(new Error('请输入正确的统一社会信用代码！'))
          } else {
            if (value.length != 18) {
              callback(new Error('请输入正确的统一社会信用代码！'))
            } else {
              callback();
            }
          }
        } else {
          callback();
        }
      } else {
        callback(new Error('请输入正确的统一社会信用代码！'))
      }

    },
  }
}
</script>
<style lang="stylus" scoped>
.cardMesSty {
  display: flex;
  align-items: center;
}

.changeClass {
  display: flex;

  div {
    width: 74px;
    line-height: 32px;
    border-radius: 2px 0px 0px 2px;
    border: 1px solid #D9D9D9;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
    text-align: center;
    font-style: normal;
  }

  .active {
    color: #336EB0;
    border: 1px solid #336EB0;
  }
}

.title {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 22px;
  text-align: left;
  font-style: normal;
  align-items: center;
  display: flex;
  margin-top: 24px;
  padding-bottom: 16px;

  i {
    width: 2px;
    height: 14px;
    display: block;
    background: #336EB0;
    margin-right: 10px;
  }
}

.formSty {
  /deep/ .el-form-item__label {
    line-height: 20px;
  }

  /deep/ .el-input--medium .el-input__inner {
    height: 32px;
    line-height: 32px;
  }
}

/deep/ .el-form--inline .el-form-item {
  margin-right: 32px;
}

/deep/ .el-dialog__body {
  padding: 20px 0 20px 30px;
  border-bottom: 2px solid #EEEEEE;
}

/deep/ .el-dialog__header {
  padding: 0;
  background: rgba(52, 109, 176, 0.06);
  border-radius: 2px 2px 0px 0px;

  .el-dialog__title {
    display: block;
    line-height: 56px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.85);
    text-align: left;
    font-style: normal;
    padding-left: 30px;
  }
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
}

.btn_Sub {
  width: 64px;
  line-height: 33px;
  background: #336EB0;
  border-radius: 2px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #FFFFFF;
  text-align: center;
  font-style: normal;
  padding: 0;
}

.btn_Clo {
  width: 64px;
  line-height: 33px;
  border-radius: 2px;
  border: 1px solid #D9D9D9;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.85);
  text-align: center;
  font-style: normal;
  padding: 0;
  margin-left: 8px;
}
</style>
